module.exports = __webpack_public_path__ + "static/media/sot_logo.86e07bdb.png";